module.exports = __webpack_public_path__ + "static/img/mogos_200@2x.aef7f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/mogos_200@2x.png
// module id = 595
// module chunks = 0